import { useVahakMutationQuery } from "@vahak/core/dist/hooks/useVahakQueryClient";
import useVahakHttpClient from "@vahak/core/dist/hooks/useVahakHttpClient";
import API from "@vahak/core/dist/_services/const";
import { QueryNames } from "@vahak/core/dist/_services/hooks/queryNames";
import { ApiErrorResponseType } from "@vahak/core/dist/custom-types";

interface Params {
    csCompanyId: number;
    ticketId?: number;
    override?: boolean;
}

interface GetTicketApiResponse {
    data: {
        message: string;
    };
}

export const useAssignTicket = () => {
    const { POST } = useVahakHttpClient();

    const method = (params: Params) => {
        const payload = {
            company_id: params?.csCompanyId,
            ticket_id: params?.ticketId,
            override: params?.override
        };
        return POST<typeof payload, GetTicketApiResponse>(API.ASSIGN_TICKET, payload);
    };

    return useVahakMutationQuery<GetTicketApiResponse, ApiErrorResponseType, Params>(
        [QueryNames.ticketSystem.assignTicket],
        method
    );
};
